'use client';
import { useEffect, useRef } from 'react';
import { Data, DialogInstance, FormRules } from 'tdesign-react';

import {
  Button,
  DialogPlugin,
  Form,
  FormProps,
  Input,
  Link,
  MessagePlugin,
} from 'tdesign-react';
import {
  useIntlGlobalData,
  UserInfo,
  addSupplementInfo,
  skipSupplementInfo,
} from '@ssv-website/hooks/intl-hook';
import { useMedia } from '@ssv-website/hooks';

const CreateSupplementInfoBody = ({
  onSubmit,
  onIgnore,
}: {
  onSubmit: (fields: any) => void;
  onIgnore: () => void;
}) => {
  const [form] = Form.useForm();
  const handleSubmit: FormProps['onSubmit'] = (values) => {
    if (values.validateResult === true) {
      onSubmit(values.fields);
    }
  };
  const rules: FormRules<Data> = {
    company: [{ required: true, message: 'Please enter your company' }],
  };
  return (
    <>
      <div className="flex flex-col mb-5">
        <div className="text-2xl  text-[#121c59] font-700">
          Complete Your Profile
        </div>
        <div className="text-sm text-[#121c59]/40">
          Please provide a few more details to enhance your experience
        </div>
      </div>
      <Form
        labelAlign={'top'}
        form={form}
        rules={rules}
        onSubmit={handleSubmit}
      >
        <Form.FormItem label="Name" name="name" className="text-lg font-500">
          <Input size="large" placeholder="e.g.,John Doe" />
        </Form.FormItem>
        <Form.FormItem
          label="Company / Organization"
          name="company"
          className="text-lg"
        >
          <Input size="large" placeholder="e.g.,Acme Corporation" />
        </Form.FormItem>
        <Form.FormItem label="Position" name="position" className="text-lg">
          <Input size="large" placeholder="e.g.,Software Engineer" />
        </Form.FormItem>
        <div className="flex flex-col items-center justify-center mt-8">
          <Button
            block
            variant="base"
            type="submit"
            className="!h-10 !bg-[#1C3FF0]"
          >
            Submit
          </Button>
          <Link
            hover="color"
            className="mt-4 !text-[#1C3FF0]"
            onClick={onIgnore}
          >
            ignore
          </Link>
        </div>
      </Form>
    </>
  );
};

function ShowSupplementInfoModal({
  onSaveSuccess,
  onIgnore,
  isMobile,
}: {
  onSaveSuccess?: () => void;
  onIgnore?: () => void;
  isMobile: boolean;
}) {
  const handleSubmit = (fields: any) => {
    const { name, company, position } = fields || {};
    addSupplementInfo({
      firstName: name,
      name: name,
      company,
      position,
    }).then(() => {
      MessagePlugin.success({ zIndex: 1000000, content: 'SUCCESS' });
      modalInstance.hide();
      onSaveSuccess?.();
    });
  };
  const handleIgnore = () => {
    skipSupplementInfo().then(() => {
      modalInstance.hide();
      onIgnore?.();
    });
  };
  const modalInstance = DialogPlugin.alert({
    closeBtn: true,
    closeOnEscKeydown: true,
    closeOnOverlayClick: true,
    preventScrollThrough: true,
    footer: false,
    showOverlay: true,
    mode: 'modal',
    placement: 'center',
    width: isMobile ? '88%' : 500,
    header: false,
    destroyOnClose: true,
    body: (
      <CreateSupplementInfoBody
        onSubmit={handleSubmit}
        onIgnore={handleIgnore}
      />
    ),
    onClose: () => {
      console.log('onClose');
    },
  });
  return modalInstance;
}

export const SupplementUserInfo = () => {
  const modalInstance = useRef<DialogInstance | null>(null);
  const { userInfo, refreshUserInfo } = useIntlGlobalData();
  const isMobile = useMedia('mobile');
  useEffect(() => {
    const { skipStatus, company } = userInfo || ({} as UserInfo);
    if (!modalInstance.current && skipStatus === 0 && !company) {
      modalInstance.current = ShowSupplementInfoModal({
        isMobile,
        onSaveSuccess() {
          refreshUserInfo();
          modalInstance.current = null;
        },
        onIgnore() {
          modalInstance.current = null;
        },
      });
    }
  }, [refreshUserInfo, userInfo]);
  return null;
};
